import React, { useEffect, useState } from "react";
import { List, ListItem } from "react-onsenui";
import { useTranslation } from "react-i18next"; // Import translation hook

const ListTendersScreen = ({ navigator }) => {
  const { t } = useTranslation(); // Initialize translation hook
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    // Dummy data with provided video links and titles
    const dummyVideos = [
      { title: t("Step 1: Community Forest Right (CFR) Claim under FRA 2006"), link: "https://www.youtube.com/watch?v=6BzBFWuASTo" },
      { title: t("Step 2: Community Forest Right (CFR) Claim under FRA 2006"), link: "https://www.youtube.com/watch?v=dm0VVVDlVuA" },
      { title: t("Step 3 and 4: Joint Meeting with Neighboring Villages and Physical Verification"), link: "https://www.youtube.com/watch?v=qbvsxcRetso" },
      { title: t("Step 5: Final Gram Sabha for the Submission of Community Forest Resource Claim under FRA 2006"), link: "https://www.youtube.com/watch?v=5Gyy9RVLJGs" }
    ];
    setVideos(dummyVideos);
  }, [t]); // Add 't' as dependency to re-run effect on language change

  const handleVideoClick = (link) => {
    window.open(link, "_blank"); // Opens the link in a new tab
  };

  return (
    <div>
      <h2>{t("video_tutorials")}</h2>
      <List
        dataSource={videos}
        renderRow={(video, index) => (
          <ListItem key={index} tappable onClick={() => handleVideoClick(video.link)}>
            <div className="left">
              <img
                src={`https://img.youtube.com/vi/${new URL(video.link).searchParams.get('v')}/0.jpg`}
                alt="thumbnail"
                style={{ width: 50, height: 50 }}
              />
            </div>
            <div className="center">
              <span>{video.title}</span>
            </div>
          </ListItem>
        )}
      />
    </div>
  );
};

export default ListTendersScreen;
